import { Routes } from '@angular/router';
import { Shell } from './shell/shell';
import { authGuard } from './authentication/auth.guard';

export const routes: Routes = [
  // public routes — no auth guard
  { path: 'unsubscribe', loadComponent: () => import('./public/unsubscribe/unsubscribe').then((m) => m.Unsubscribe) },
  { path: 'preferences', loadComponent: () => import('./public/preferences/preferences').then((m) => m.Preferences) },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadComponent: () => import('./dashboard/dashboard').then((m) => m.Dashboard) },
      {
        path: 'contacts/:id/activity',
        loadComponent: () => import('./contact-activity/contact-activity').then((m) => m.ContactActivity),
      },
      { path: 'contacts', loadComponent: () => import('./contacts/contacts').then((m) => m.Contacts) },
      { path: 'lists', loadComponent: () => import('./lists/lists').then((m) => m.Lists) },
      {
        path: 'campaigns/:id/performance',
        loadComponent: () => import('./campaign-performance/campaign-performance').then((m) => m.CampaignPerformance),
      },
      { path: 'campaigns', loadComponent: () => import('./campaigns/campaigns').then((m) => m.Campaigns) },
      { path: 'enrichment', loadComponent: () => import('./enrichment/enrichment').then((m) => m.Enrichment) },
      { path: 'templates', loadComponent: () => import('./templates/templates').then((m) => m.Templates) },
      {
        path: 'template-creator',
        loadComponent: () => import('./template-creator/template-creator').then((m) => m.TemplateCreator),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
